/**
 * Remove a formatação de um número de telefone brasileiro
 * @param value - String contendo o número de telefone formatado
 * @returns String com apenas os números ou string vazia se inválida
 */
export function removeFormatPhone(value: string | null | undefined): string {
  if (!value || value.trim() === '') {
    return '';
  }

  let cleanValue = value.replace(/\D/g, '');
  if (cleanValue.length === 0) {
    return '';
  }

  if (cleanValue.startsWith('55') && cleanValue.length > 10) {
    cleanValue = cleanValue.substring(2);
  }

  return cleanValue;
}
